<template>
  <div @click="$emit('close')" class="popin-marketing u-row u-center u-middle u-z-front">
    <div @click.stop="()=>{return}" class="popin-marketing__wrapper u-w8of12 u-w10of12--sm u-box-16by9 u-box-none--sm u-bg-white u-radius">
      <div class="popin-marketing__item u-wrapper-panel u-row u-pad-lg u-pad-md--sm">
        <div class="u-w4of12 u-w12of12--sm u-pad-x-lg--sm u-marg-y-md--sm">
          <app-image :width="500" :id="data.image[0].id" fit="contain" class="u-block u-fit-contain" />
        </div>
        <div class="u-w6of12 u-marg-l-1of12 u-w12of12--sm u-marg-l-0--sm u-flex u-left u-middle">
          <div>
            <div class="t-h3">
              {{ data.title }}
            </div>
            <div class="t-text--small u-marg-t-md">
              {{ data.text }}
            </div>
            <div class="u-marg-t-md u-center--sm">
              <app-button :key="index" :url="cta.url" v-for="(cta, index) in data.cta" class="u-marg-r-sm">
                {{ cta.label }}
              </app-button>
            </div>
          </div>
        </div>
        <div @click="$emit('close')" class="popin-marketing__close u-cursor-pointer">
          <svg class="u-full-width u-full-height u-stroke-blue" preserveAspectRatio="xMidYMid meet">
            <use xlink:href="#close"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/common/AppButton'


export default {
  props: {
    data: {
      type: Object,
      default: () => {return {}}
    }
  },

  components: {
    AppButton
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/mq'
@import '~@/styles/settings/variables'

.popin-marketing
  position fixed
  top 0
  left 0
  height 100vh
  width 100%
  
  &:before
    content ''
    position absolute
    top 0
    left 0
    height 100%
    width 100%
    background-color: $colors.black
    opacity .5
  
  &__wrapper
    max-height 70%
  
  &__item
    +mq($until: 'tablet')
      position relative
      top auto
      left auto

  &__close
    top -50px
    position absolute
    left calc( 50% - 50px )
    width 100px
    height 100px
    background: $colors.white
    padding 30px
    border-radius 100%
    
</style>